export const UPDATE_MAIN = "[main] update main";
export const MAIN_UPDATE_USERS = "[main] update users";
export const MAIN_UPDATE_WHATSAPP_STATUS = "[main] update whatsapp_status";
export const MAIN_UPDATE_CREDENTIALS = "[main] update credentials";

// All contacts actions
export const UPDATE_CONTACT_LIST = "[main] update contacts";
export const ADD_CONTACT_FROM_LIST = "[main] add contact from list";
export const UPDATE_CONTACT_FROM_LIST = "[main] update contact from list";
export const REMOVE_CONTACT_FROM_LIST = "[main] remove contact from list";
export const OVERWRITE_TOTALS = "[main] overwrite totals";
export const CONTACTS_LOADING = "[main] loading contacts";

// Search by key world actions
export const OVERWRITE_SEARCH_CONTACTS = "[main] overwrite search contacts";

// Filter actions
export const UPDATE_FILTER_CONTACT_LIST = "[main] filter update contacts";
export const ADD_FILTER_CONTACT = "[main] filter add contact from list";
export const UPDATE_FILTER_CONTACT = "[main] filter update contact from list";
export const REMOVE_FILTER_CONTACT = "[main] filter remove contact from list";
export const OVERWRITE_FILTER_TOTALS = "[main] filter overwrite totals";
export const SET_FILTER_USERS = "[main] set filter users";
export const SET_FILTER_TAGS = "[main] set filter tags";
export const SET_FILTER_SCOPE = "[main] set filter scope";
export const SET_FILTER_TEAMS = "[main] set filter teams";
export const CLEAR_ALL_FILTERS = "[main] clear all filter";
